module.exports = __webpack_public_path__ + "static/media/umpLogo.8c6c6cbe.svg";